const PRODUCTION_URL =
  process.env.REACT_APP_API_URL ||
  "https://t-global-backend-v3-1050393382437.us-central1.run.app";

export const getBackendUrl = () =>
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1"
    ? "http://localhost:5000"
    : PRODUCTION_URL;

export const getApiUrl = () => `${getBackendUrl()}/api/bot-widget`;

// Avatar voice endpoint — returns an MP3 the browser analyses for lip-sync.
export const getTtsUrl = () => `${getBackendUrl()}/api/tts`;

// Microphone endpoint — takes one recorded question, returns its transcript.
export const getSttUrl = () => `${getBackendUrl()}/api/stt`;
